
import { IInternalAuth } from '../interfaces/inversifyDi'
import { injectable } from "inversify";

@injectable()
class InternalAuth implements IInternalAuth  {

    Check():Promise<any>{

        return new Promise<void>((resolve) => {

            // Local setup
            if (process.env.NODE_ENV === "development"){

                resolve();

                return;
            }
            else{
                resolve();
            }
        });
    }
}

export default InternalAuth;